(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CuentaappController', CuentaappController)
 
    CuentaappController.$inject = ["CuentaappService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CuentaappController(CuentaappService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;

		var today = new Date();
		var currentMonth = ('0' + (today.getMonth() + 1)).slice(-2); // Mes actual en formato 'MM'
		var currentYear = today.getFullYear().toString() 
		vm.selectedMonth = currentMonth;
		vm.selectedYear = currentYear;
		vm.facturacion_total = "";
		vm.pedidosPrecio = false;

        vm.getInfoCentro = function(centro_sso){
			console.log("centro sso", centro_sso)
        	CuentaappService.getInfoCentro(centro_sso, vm.selectedMonth, vm.selectedYear, function(data){
				console.log("data info centro", data)
				if(data.infoCentro.code > 0){
					vm.pedidosPrecio = data.infoCentro.pedidosPrecio;
				}else{
					vm.pedidosPrecio = false;
				}

				if(data.infoCentro.facturacionPrevista.code > 0){
					vm.facturacion_total = data.infoCentro.facturacionPrevista.facturacion_total
					vm.facturacion_peticiones = data.infoCentro.facturacionPrevista.facturacion_peticiones
					vm.facturacion_material = data.infoCentro.facturacionPrevista.facturacion_material
				}

				if(data.lecturasSm != "false"){
					console.log("no es false");
					vm.ultimasLecturas = data.lecturasSm;
				}else{
					vm.ultimasLecturas = false;
				}
        	});

        }

		vm.getFacturacionPrevista = function(centro_sso){
			CuentaappService.getFacturacionPrevista(centro_sso,vm.selectedMonth, vm.selectedYear, function(data){
				console.log("data get facturas centro", data)
				if(data.code>0){
					vm.facturacion_total = data.facturacion_total
					vm.facturacion_peticiones = data.facturacion_peticiones
					vm.facturacion_material = data.facturacion_material
				}
			});
		}
        
    }
  
})();